import { useSelector } from "react-redux";

const useDestinations = () => {
    const destinations = useSelector((state) => state.destinations);
    return destinations;
};

export default useDestinations;